const ClosedEye = ({ className, stroke = 'white' }) => (
  <svg
    width='25'
    height='26'
    viewBox='0 0 25 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <g id='Group'>
      <path
        id='Path'
        d='M14.6681 14.5577C14.0285 15.6361 12.7863 16.2036 11.5524 15.9811C10.3186 15.7585 9.35287 14.7928 9.13034 13.559C8.90781 12.3251 9.47531 11.0829 10.5537 10.4434'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Path_2'
        d='M18.1065 17.9961C16.3817 19.3043 14.2747 20.0094 12.1099 20.0028C8.52284 20.0667 5.20848 18.0953 3.55237 14.9127C2.95748 13.7069 2.95748 12.2929 3.55237 11.0871C4.38062 9.43773 5.70092 8.08646 7.33067 7.22021'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Path_3'
        d='M20.5374 15.1345C20.5775 15.0585 20.6297 14.9903 20.6677 14.9128C21.2626 13.707 21.2626 12.293 20.6677 11.0872C19.0116 7.90465 15.6972 5.93323 12.1101 5.99711C11.8852 5.99711 11.6666 6.02712 11.4446 6.04175'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Path_4'
        d='M21.1138 21.0037L4.10669 3.99658'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
)

export default ClosedEye
